import cx from 'classnames';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import Typography from '~/components/Typography';
import type { Publication } from '~/interfaces/publication';

interface Props {
  publication: Publication;
}

const PublicationDetails = ({ publication }: Props) => {
  const { webTheme } = useWebThemeContext();

  return (
    <div className="flex w-full flex-col items-center sm:items-start">
      <div className="flex items-center gap-x-2 py-4">
        <img
          src={publication.logo.thumb.url}
          alt={publication.description}
          width={40}
          height={40}
          className={cx('overflow-hidden')}
        />
        <Typography
          as="p"
          size="md"
          weight="semibold"
          color={webTheme?.footer_text_color}
          fontFamilyv2={webTheme?.font_body}
        >
          {publication.name}
        </Typography>
      </div>
      <div className="text-center sm:text-left">
        <Typography
          as="p"
          size="sm"
          weight="regular"
          color={webTheme?.footer_text_color}
          fontFamilyv2={webTheme?.font_body}
        >
          {publication.description}
        </Typography>
      </div>
    </div>
  );
};

export default PublicationDetails;
